import { koComponent } from '../../ko-utils';
import { FeedbackDesign } from '../../models/Gen/TrackableBaseModels';
import $api from '../../api';
import ColorPicker from '../../components/colorPicker';
import { beginNoTracking, endNoTracking } from '../../utils/changeTracking';

class AppearanceSettingsView {
    constructor(params, customParams) {
        ColorPicker();

        this.parentPage = customParams.parentPage;

        this.design = params.$raw.designObject();

        this.design.noTracking = true;
        if (!this.design()) {
            this.design(new FeedbackDesign());
        } else {
            this.design(new FeedbackDesign(this.design())); // hack
        }
        this.design.noTracking = false;

        for (const prop in this.design()) {
            if (ko.isObservable(this.design()[prop])) {
                this.design()[prop].subscribe(() => this.parentPage.updatePreview());
            }
        }
    }

    save() {
        this.parentPage.startSubmitting();
        $api.projects.saveFeedbackDesign(
            { projectCode: auth.project.UniqueCode },
            this.design().toJS(),
            () => {
                this.parentPage.stopSubmitting();
                this.parentPage.showToast('Feedback appearance saved.');
            }
        );
    }
}

export default koComponent('appearance-settings', AppearanceSettingsView);